<template lang="pug">
  .row.shipment-details
    .col-sm-12
      .panel.panel-default
        .panel-body
          .col-sm-6
            .row
              label.col-sm-4 Code
              .col-sm-8.kzcode-default {{ shipment.code }}

            .row
              label.col-sm-4 Status
              .col-sm-8.bold {{ shipment.status | underscore }}

            .row(v-if="shipment.closed")
              label.col-sm-4 Closed
              .col-sm-8 {{ shipment.closed | date }}

            .row
              label.col-sm-4 Reference
              .col-sm-8 {{ shipment.externalReference }}

            .row
              label.col-sm-4 Source Location
              .col-sm-8(v-if="shipment.originLocation") {{ shipment.originLocation.name }}

            .row
              label.col-sm-4 Shipping Location
              .col-sm-8(v-if="shipment.targetLocation") {{ shipment.targetLocation.name }}

            .row
              label.col-sm-4 Created
              .col-sm-8 {{ shipment.created | date }}

            .row
              label.col-sm-4 Created By
              .col-sm-8 {{ shipment.createdBy.username }}

            .row
              label.col-sm-4 Notes
              .col-sm-8 {{ shipment.notes }}

            .row
              label.col-sm-4 Size
              .col-sm-8 {{ shipment.size }}

            .row
              label.col-sm-4 Free Picking
              .col-sm-8 {{ shipment.freePicking ? 'Yes' : 'No' }}

            .row
              label.col-sm-4 Excpected Delivery Date
              .col-sm-8 {{ shipment.expectedDeliveryDate | date }}

            .row
              label.col-sm-4 Codes
              .col-sm-8
                button.btn.btn-default.btn-sm(@click="isCollapsed = !isCollapsed" :class="{collapsed: isCollapsed}" v-if="items")
                  i.fa(:class="{ 'fa fa-plus': isCollapsed , 'fa fa-minus': !isCollapsed }")
                  span.ml5 Codes
                em.text-muted(v-else) No Codes
                .parent
                  router-link.child.kzcode-default(:key="index" v-for="(i, index) in items" v-if="!isCollapsed" :to="{ name: 'traceDetails', params: { code: i.code} }") {{i.code}}

          .col-sm-6(v-if="skus")
            DataGrid(ref="grid" :fetch="fetchData" :withoutPagination="true")
              tr(slot="thead")
                th Name
                th Count
                th Picked
              tr(v-for="s in skus")
                td {{s.name}}
                td {{s.count}}
                td {{s.picked}}
</template>

<script>
import { dateFilter, replaceUnderscore } from '@/filters/filters'
import DataGrid from '@/components/ssp/DataGrid'

export default {
  props: {
    shipment: {
      type: Object,
      required: true
    },
    skus: {
      type: Array
    },
    items: {
      type: Array
    }
  },
  data: () => ({
    isCollapsed: true
  }),
  methods: {
    fetchData() {
      return new Promise((resolve) => {
        resolve(this.skus.length)
      })
    }
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter,
    underscore: replaceUnderscore
  }
}
</script>

<style lang="scss">
.shipment-details {
  .table-footer {
    background-color: #efefef !important
  }
  .parent {
    display: flex;
    flex-wrap:wrap;
  }
  .child {
    display: inline-block;
    width: calc(100% * (1/2))
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/shipments/ShipmentDetails.vue